import { __assign } from "tslib";
import * as React from 'react';
function IconEyeSizeS(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 16 16" }, props),
        React.createElement("path", { d: "M8 3C4.364 3 1.258 5.28 0 8.5 1.258 11.72 4.364 14 8 14s6.742-2.28 8-5.5C14.742 5.28 11.636 3 8 3zm0 9.167c-2.007 0-3.636-1.643-3.636-3.667S5.993 4.833 8 4.833s3.636 1.643 3.636 3.667S10.007 12.167 8 12.167zM8 6.3a2.188 2.188 0 00-2.182 2.2c0 1.217.975 2.2 2.182 2.2a2.188 2.188 0 002.182-2.2c0-1.217-.975-2.2-2.182-2.2z" })));
}
export default IconEyeSizeS;
